export const propsOptions = {
    "block": "Bloque de Yoga",
    "strap": "Cinta / Cinturón",
    "bolster": "Bolster / Cojín firme",
    "blanket": "Manta / Cobija",
    "chair": "Silla",
    "wall": "Pared (Apoyo)",
    "wheel": "Rueda de Yoga (Wheel)",
    "ball": "Pelota pequeña / Fitball"
};